
import { computed, defineComponent } from 'vue';
import Alert from '@/common/components/Alert.vue';
import { INotification } from '@/common/api/runtime/INotification';
import { Instance as CatalogsInstance } from '@/catalogs/api/Instance';
import { Instance as ProductsInstance } from '@/products/api/Instance';
import { Instance as ClassificationsInstance } from '@/classifications/api/Instance';

type AnyInstance = CatalogsInstance | ProductsInstance | ClassificationsInstance;

export default defineComponent({
  components: {
    Alert,
  },
  props: {
    instance: { type: Object as () => AnyInstance, required: true },
  },
  setup(props) {
    const notifications = computed(() => props.instance.store.notifications);

    const onClosed = (notification: INotification) => {
      let notifications: INotification[] = props.instance.store.notifications;
      if (notifications && notifications.includes(notification)) {
        notifications.splice(notifications.indexOf(notification), 1);
      }
    };

    return {
      notifications,
      onClosed,
    };
  },
});
